<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import { slide } from 'svelte/transition';

    const dispatch = createEventDispatcher();
    export let msg_type = 'info';
    export let msg_content = '';
    export let msg_shown = false;
    export let msg_action = 'OK';
    export let msg_color = false;
    $: msg_content, document.body.classList[msg_shown ? 'add' : 'remove']('noscroll');
    // onMount(() => {
    //     // $: msg_shown, getFocus();
    //     function getFocus() {
    //         if (msg_shown) {
    //             document.getElementById('modal_close').focus();
    //         }
    //     }
    //     getFocus();
    // });
    // const close = (e) => {
    //     if (e.keyCode === 27) {
    //         msg_shown = false;
    //     }
    // };
</script>

{#if msg_shown}
    <div
        transition:slide
        class="box-border fixed z-10 grid w-full h-full p-5 overflow-auto bg-blue-200 obelisk "
    >
        <div
            class="p-5 text-center text-white bg-blue-100 border-4 border-white border-opacity-50 place-self-center dialog max-w-prose"
            style={msg_color ? '--theme-color:' + msg_color : ''}
            data-type={msg_type}
        >
            <i class="mt-2 mb-6 fa-solid icon fa-fw fa-3x" aria-hidden="true" />
            <h3 class="mb-5">{msg_content}</h3>
            <button
                on:click={() => {
                    msg_shown = false;
                    dispatch('msg', false);
                }}>{msg_action}</button
            >
        </div>
    </div>
{/if}

<style>
    :root {
        --theme-color: white;
    }

    /* error */
    [data-type='error'] {
        --theme-color: #e24949;
    }
    .dialog[data-type='error'] .icon::before {
        content: '\f057';
    }
    /* info */
    [data-type='info'] {
        --theme-color: #50e2be;
    }
    .dialog[data-type='info'] .icon::before {
        content: '\f05a';
    }
    /* check */
    [data-type='check'] {
        --theme-color: #51df67;
    }
    .dialog[data-type='check'] .icon::before {
        content: '\f058';
    }
    /* warn */
    [data-type='warn'] {
        --theme-color: #f7db00;
    }
    .dialog[data-type='warn'] .icon::before {
        content: '\f06a';
    }

    div.dialog {
        /* background-color: var(--theme-color); */
        border-color: var(--theme-color);
    }
    .dialog .icon {
        color: var(--theme-color);
    }
</style>
